import React from "react";
import { Pageheader } from "./global-components/page-header";
import bgImage from '../assets/img/newimgaes/Sales Main Photo.jpeg';
import comingSoon from '../assets/img/banner/commingsoon.jpg';
import { Card, Container, Box } from "@mui/material";

export const AllContries = () => {
  return (
    <>
      <Pageheader headertitle="All Countries" bgImage={bgImage} />

      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            p: { xs: 2, sm: 3 },
          }}
        >
          <Box
            component="img"
            src={comingSoon}
            alt="Coming Soon"
            sx={{
              width: { xs: '100%', sm: '90%', md: '80%' },
              height: 'auto',
              borderRadius: 1,
              objectFit: 'contain',
            }}
          />
        </Card>
      </Container>
    </>
  );
};
